import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon, XIcon } from 'lucide-react';
import { saveDisplayName } from '../authService';
interface NicknamePromptModalProps {
  onComplete: () => void;
}
export const NicknamePromptModal: React.FC<NicknamePromptModalProps> = ({
  onComplete
}) => {
  const [nickname, setNickname] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handleSave = async () => {
    if (!nickname.trim()) {
      setError('Please enter a nickname');
      return;
    }
    setIsSubmitting(true);
    setError('');
    try {
      const success = await saveDisplayName(nickname.trim());
      if (success) {
        onComplete();
      } else {
        setError('Failed to save nickname. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleStayAnonymous = () => {
    onComplete();
  };
  return <motion.div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} data-id="element-60">
      <motion.div className="bg-background-light border-2 border-gray-800 rounded-lg p-8 max-w-md w-full relative" initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.9,
      opacity: 0
    }} data-id="element-61">
        <div className="text-center mb-6" data-id="element-62">
          <motion.div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4" initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 10
        }} data-id="element-63">
            <UserIcon className="h-8 w-8 text-primary" data-id="element-64" />
          </motion.div>
          <h2 className="text-2xl font-bold mb-2" data-id="element-65">Pick Your Nickname</h2>
          <p className="text-text-secondary" data-id="element-66">
            Choose a display name for your rants and replies, or stay anonymous.
          </p>
        </div>
        <div className="space-y-4" data-id="element-67">
          <div data-id="element-68">
            <input type="text" value={nickname} onChange={e => setNickname(e.target.value)} placeholder="Your nickname (optional)" className="w-full px-4 py-3 bg-background text-text-primary border border-gray-700 rounded-lg focus:outline-none focus:border-primary transition-all placeholder-text-secondary" disabled={isSubmitting} maxLength={50} data-id="element-69" />
            {error && <p className="text-red-500 text-sm mt-2" data-id="element-70">{error}</p>}
          </div>
          <div className="flex flex-col gap-3" data-id="element-71">
            <motion.button onClick={handleSave} className="w-full btn-primary py-3 px-6 rounded-lg font-semibold" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} disabled={isSubmitting} data-id="element-72">
              {isSubmitting ? 'Saving...' : 'Save'}
            </motion.button>
            <motion.button onClick={handleStayAnonymous} className="w-full py-3 px-6 rounded-lg border border-gray-700 hover:border-primary text-text-primary hover:text-primary transition-colors font-semibold" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} disabled={isSubmitting} data-id="element-73">
              Stay Anonymous
            </motion.button>
          </div>
        </div>
      </motion.div>
    </motion.div>;
};